<div *ngIf="dirty && errors">
	<div
		*ngIf="errors.required && !this.controlDisplayName"
		class="invalid-feedback">
		This {{ this.controlName }} is required.
	</div>
	<div
		*ngIf="errors.required && this.controlDisplayName"
		class="invalid-feedback">
		This {{ this.controlDisplayName }} is required.
	</div>
	<div
		*ngIf="errors.notInteger && !this.controlDisplayName"
		class="invalid-feedback">
		The {{ this.controlName }} is invalid, must be only integers.
	</div>
	<div
		*ngIf="errors.notInteger && this.controlDisplayName"
		class="invalid-feedback">
		The {{ this.controlDisplayName }} is invalid, must be only integers.
	</div>

	<div
		*ngIf="errors.noBoxSelected"
		class="invalid-feedback">
		Please select at least one label to be printed.
	</div>
	<div
		*ngIf="errors.uiErrors"
		class="invalid-feedback">
		{{ errors.message }}
	</div>
	<ng-container *ngIf="errors.apiErrors">
		<ng-container *ngFor="let message of errors.apiErrors">
			<div class="invalid-feedback">{{ message }}</div>
		</ng-container>
	</ng-container>
</div>
